var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',[_c('v-row',[_c('v-img',{staticClass:"ml-4",attrs:{"src":'data:image/png;base64, ' + _vm.app.logo,"max-height":"80","max-width":"80"}}),_c('v-card-title',[_vm._v(" "+_vm._s(_vm.app.name)+" ")])],1),_c('v-card-text',[_c('v-row',[_vm._v("\n            "+_vm._s(_vm.app.description)+"\n        ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }